var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStar = function SvgStar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#009270"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_574_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1602 7.96789L10.3984 9.50539L10.9262 11.7945C10.9541 11.9141 10.9461 12.0394 10.9033 12.1545C10.8604 12.2697 10.7845 12.3697 10.6852 12.4419C10.5858 12.5142 10.4673 12.5556 10.3446 12.5609C10.2218 12.5662 10.1002 12.5352 9.99493 12.4718L7.99845 11.2609L6.00626 12.4718C5.90101 12.5352 5.77941 12.5662 5.65664 12.5609C5.53387 12.5556 5.4154 12.5142 5.31602 12.4419C5.21665 12.3697 5.14078 12.2697 5.09792 12.1545C5.05505 12.0394 5.04708 11.9141 5.07501 11.7945L5.60196 9.50774L3.83985 7.96789C3.74665 7.88751 3.67926 7.7814 3.64612 7.66287C3.61299 7.54434 3.61559 7.41867 3.65359 7.30161C3.6916 7.18455 3.76332 7.08131 3.85976 7.00485C3.9562 6.92839 4.07307 6.8821 4.19571 6.8718L6.51837 6.67063L7.42501 4.50813C7.47236 4.39465 7.55222 4.29773 7.65454 4.22955C7.75685 4.16138 7.87706 4.125 8.00001 4.125C8.12296 4.125 8.24317 4.16138 8.34548 4.22955C8.4478 4.29773 8.52766 4.39465 8.57501 4.50813L9.48438 6.67063L11.8063 6.8718C11.9289 6.8821 12.0458 6.92839 12.1422 7.00485C12.2387 7.08131 12.3104 7.18455 12.3484 7.30161C12.3864 7.41867 12.389 7.54434 12.3558 7.66287C12.3227 7.7814 12.2553 7.88751 12.1621 7.96789H12.1602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_574_1960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.d807ef9a4bcecc66debf2b181c1a7ca7.svg";